<template>
  <section :class="['flex', { 'app-loading__overlay': fullScreen }]">
    <div
      :class="[
        'app-loading m-auto',
        {
          'app-loading--small': small,
          'app-loading--white': white,
          'app-loading--medium': medium,
        },
      ]"
    >
      <div class="app-loading__item" role="status">
        <span class="app-loading__item__inner">Loading...</span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  fullScreen?: boolean
  small?: boolean
  white?: boolean
  medium?: boolean
}>()
</script>
